import { RootState } from '../../../app/store';
import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit"
import CashAccountModel from '../models/CashAccountModel';

interface CashAccountState {
    cashAccounts: CashAccountModel[],
    showCashAccountModel: boolean,
    input: CashAccountModel,
    triggerRefreshTable: number,
    datatableSelectedIndex: number,
}

const initialState: CashAccountState = {
    cashAccounts: [],
    showCashAccountModel: false,
    input: {
        id: "",
        country: "",
        account: "",
        currency: "",
    } as CashAccountModel,
    triggerRefreshTable: 0,
    datatableSelectedIndex: -1,
}

export const CashAccountSlice = createSlice({
    name: "CashAccount",
    initialState,
    reducers: {
        setShowCashAccount: (state, action: PayloadAction<boolean>) => {
            state.showCashAccountModel = action.payload;
        },
        setCashAccounts: (state, action: PayloadAction<CashAccountModel[]>) => {
            state.cashAccounts = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.input.country = action.payload;
        },
        setAccount: (state, action: PayloadAction<string>) => {
            state.input.account = action.payload;
        },
        setCurrency: (state, action: PayloadAction<string>) => {
            state.input.currency = action.payload;
        },
        setInput: (state, action: PayloadAction<CashAccountModel>) => {
            state.input = action.payload;
        },
        refreshInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerRefreshTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshTable = action.payload;
        },
        setDatatableSelectedCashAccountIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
    }
});

export const CashAccountSelector = createSelector(
    (state: RootState) => state.cashAccount,
    (data) => data
);

export const {
    setShowCashAccount,
    setCashAccounts,
    setCountry,
    setAccount,
    setCurrency,
    refreshInput,
    setInput,
    setTriggerRefreshTable,
    setDatatableSelectedCashAccountIndex
} = CashAccountSlice.actions;

export default CashAccountSlice.reducer;